import { createFileRoute } from "@tanstack/react-router";

import { Landing } from "@/features/marketing/Landing";

export const Route = createFileRoute("/")({
  component: Landing,
});
